// (A) 중립 명령형 message API. React hook 판. antd 미접촉 — (B) useMessageImpl 에 위임.
import type { ReactNode } from 'react'
import { useMessageImpl } from '../_impl/useMessageImpl'

// antd message 옵션 파리티(현재는 duration 만 노출). duration 초 단위, 0 이면 자동 닫힘 없음.
export interface OmwMessageOptions {
  duration?: number
}

// content 는 문자열이 기본이나, 리치 노드 토스트(실측: pages/main ErrorEx.msgNode)도 허용.
export interface OmwMessageApi {
  success: (content: ReactNode, options?: OmwMessageOptions) => void
  error: (content: ReactNode, options?: OmwMessageOptions) => void
  info: (content: ReactNode, options?: OmwMessageOptions) => void
  warning: (content: ReactNode, options?: OmwMessageOptions) => void
}

export function useMessage(): OmwMessageApi {
  return useMessageImpl()
}
